import { Box, styled } from '@mui/material';
import { spaceCadet } from '../../../../../../../../../../utils/colors';

const StyledBox = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  padding: 8,
  border: `1px solid ${spaceCadet[300]}`,
  borderRadius: 4,
  gap: 8,
  '& > .MuiBox-root.header': {
    display: 'flex',
    gap: 4,
    justifyContent: 'space-between',
    '& > .MuiTypography-subtitle1': {
      color: spaceCadet[400],
      fontWeight: 600,
      textTransform: 'uppercase',
      lineHeight: '24px',
      fontSize: 14,
    },
  },
  '& > .MuiBox-root.content': {
    display: 'flex',
    flexDirection: 'column',
    gap: 4,
  },
});

export default StyledBox;
